import { v4 as uuidv4 } from 'uuid';

export const eventData = (eventName: string) => ({
    event: eventName,
    event_id: `${eventName}_${uuidv4()}`,
    nf_branch: window?.nf_branch
});